import axios from 'axios';
import { _GetX32, _GetX64, _GetX128 } from './ObtenerDireccion';
import { GetKey } from './GetKey';
import { Val01, Val02, Val03, Val04, Val05, Val06, Val07, Val08, Val09, Val10, Val11, Val12, Val13, Val14, Val15, Val16, Val17, Val18, Val19, Val20, Val21, Val22, Val23, Val24, Val25, Val26, Val27, Val28, Val29, Val30}  from '../data/auxdata';

async function ActualizarClave(prmUsuario: string, prmClave: string, prmClaveNueva: string) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/cambiar_clave"

    const key01 = GetKey(171,0);
    const key02 = GetKey(117,2);
    const key03 = GetKey(172,0);
    const key04 = GetKey(172,1);
    const key05 = GetKey(172,2);
    const key06 = GetKey(132,1);
    const key07 = GetKey(164,2);
    const key08 = GetKey(128,0);
    const key09 = GetKey(172,0);
    const key10 = GetKey(256,0);
    const key11 = GetKey(172,0);
    const key12 = GetKey(128,2);
    const key13 = GetKey(256,3);
    const key14 = GetKey(164,1);
    const key15 = GetKey(172,3);
    const key16 = GetKey(128,1);
    const key17 = GetKey(172,4);
    const key18 = GetKey(128,0);
    const key19 = GetKey(172,5);
    const key20 = GetKey(156,1);
    const key21 = GetKey(121,2);
    const key22 = GetKey(172,6);
    const key23 = GetKey(163,5);
    const key24 = GetKey(127,1);
    const key25 = GetKey(162,3);
    const key26 = GetKey(132,0);
    const key27 = GetKey(164,0);
    const key28 = GetKey(128,0);
    const key29 = GetKey(172,0);
    const key30 = GetKey(256,0);

    try {

        const data = {
            [key01]: _GetX32(Val01),
            [key02]: _GetX64(Val02),
            [key03]: _GetX32(Val03),
            [key04]: _GetX128(Val04),
            [key05]: _GetX128(Val05), 
            [key06]: _GetX128(Val06),
            [key07]: _GetX128(Val07),
            [key08]: _GetX128(Val08),
            [key09]: _GetX128(Val09),
            [key10]: _GetX128(Val10),
            [key11]: _GetX128(Val11),
            [key12]: _GetX128(Val12),
            [key13]: _GetX128(Val13),
            [key14]: _GetX128(Val14),
            [key15]: {                
                [key16]: _GetX128(Val16),
                [key17]: _GetX128(prmUsuario),
                [key18]: _GetX128(Val18),
                [key19]: _GetX128(prmClave),
                [key20]: _GetX128(Val20),
                [key21]: _GetX128(Val21)
            },
            [key22]: _GetX128(prmClaveNueva),
            [key23]: _GetX128(Val23),
            [key24]: _GetX128(Val24),
            [key25]: _GetX128(Val25),
            [key26]: _GetX128(Val26),
            [key27]: _GetX128(Val27),
            [key28]: _GetX128(Val28),
            [key29]: _GetX128(Val29),
            [key30]: _GetX128(Val30)
        };
        
        const response = await axios.post(url, data);

        return response.data;
    } catch (error) {
        return error;
    }
};

export default ActualizarClave;